import { EFinancingProgram } from '@if/core/types'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FundingSummaryButton from './FundingSummaryButton'

interface Props {
  id: string
  financingProgramId: EFinancingProgram
}

const FundingCreatingLoan = ({ id, financingProgramId }: Props) => {
  const { t } = useTranslation()
  return (
    <div>
      <Typography variant="body1">{t('viewCreditApplication.fundingProcessing')}</Typography>
      <br />
      <br />
      <FundingSummaryButton id={id} financingProgramId={financingProgramId} disabled={true} />
    </div>
  )
}

export default FundingCreatingLoan
